"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./HeaderSection.scss");
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _ExternalLink = require("../Shared/Components/ExternalLink");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HeaderSection = function HeaderSection(_ref) {
  var repositoryIsExempted = _ref.repositoryIsExempted,
    isLoading = _ref.isLoading;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(_react2.Stack, {
      tokens: {
        childrenGap: 4
      }
    }, /*#__PURE__*/React.createElement(_react2.Shimmer, null), /*#__PURE__*/React.createElement(_react2.Shimmer, {
      width: "75%"
    }));
  }
  if (repositoryIsExempted) {
    return /*#__PURE__*/React.createElement(_react2.Text, {
      block: true
    }, t("repositoryOwnerPanel.body.accountedFor.text"));
  }
  return /*#__PURE__*/React.createElement(_react2.Stack.Item, null, /*#__PURE__*/React.createElement("div", {
    className: "repository-owner-panel-title"
  }, /*#__PURE__*/React.createElement(_react2.Text, {
    as: "h2",
    id: "repository-owner-panel-title",
    variant: "xLarge"
  }, t("repositoryOwnerPanel.body.title"))), /*#__PURE__*/React.createElement(_react2.Text, null, t("repositoryOwnerPanel.body.instructions.text")), /*#__PURE__*/React.createElement(_ExternalLink.ExternalLink, {
    link: "https://aka.ms/ProductCatalogInventoryProgram_FAQ",
    metricsTag: "RepositoryOwnerPanel.Nav1esWiki",
    text: t("repositoryOwnerPanel.body.instructions.link")
  }));
};
var _default = HeaderSection;
exports.default = _default;